import { createRoot } from "solid-js";
import { createStore } from "solid-js/store";

function createToken() {

  const appName = import.meta.env.VITE_APP_NAME;

  const accessTokenKey = `${appName}AccessToken`;
  const refreshTokenKey = `${appName}RefreshToken`;

  const [token, setToken] = createStore({
    accessToken: window.localStorage.getItem(accessTokenKey) || null,
    refreshToken: window.localStorage.getItem(refreshTokenKey) || null
  });

  const setAccessToken = (accessToken) => { setToken('accessToken', accessToken); window.localStorage.setItem(accessTokenKey, accessToken) }
  const setRefreshToken = (refreshToken) => { setToken('refreshToken', refreshToken); window.localStorage.setItem(refreshTokenKey, refreshToken) }
  const clearToken = () => { setToken('accessToken', null); setToken('refreshToken', null); window.localStorage.removeItem(accessTokenKey); window.localStorage.removeItem(refreshTokenKey) }
  return { token, setAccessToken, setRefreshToken, clearToken };
}

export default createRoot(createToken);
